<script>
import { mapActions, mapGetters } from 'vuex'
import isMobile from 'ismobilejs'
import LABELS from '@/constants/labels'
import { stampsList } from '@/constants/data'
import { uniqueId } from '@/helpers/site'

export default {
  name: 'AddStamp',
  data: () => ({
    stampsList,
    chooseStamp: false,
    stampSelected: {},
    currentStampShow: null,
    controlIdx: '',
    defaultRotate: 0,
    defaultScale: 0.5,
    title: 'Stamp',
    colorIconDelete: '#ACACAC',
  }),
  methods: {
    ...mapActions('settings', [
      'setStamps',
      'saveToStorage',
      'setLayout',
      'setExport',
      'setModules',
    ]),
    handleRedirectSelectStamp() {
      this.chooseStamp = true
      window.scrollTo(0, 0)
      this.currentStampShow = this.stampsList[0].stamps[0]
    },
    handleRotate(value) {
      if (this.controlIdx) {
        this.stampSelected[this.controlIdx].rotation = value
        this.defaultRotate = +value
      }
    },
    handleZoom(value) {
      if (this.controlIdx) {
        const currentObject = this.stampSelected[this.controlIdx]
        currentObject.scaleX = +value
        currentObject.scaleY = +value

        this.defaultScale = +value
      }
    },
    handleBack(add) {
      this.chooseStamp = false
      if (add) {
        window.scrollTo(0, 0)
        const id = uniqueId('stamp')
        this.stampSelected = {
          ...this.stampSelected,
          [id]: {
            ...this.currentStampShow,
            id,
          },
        }
      }
      this.currentStampShow = null
    },
    handleSelectStamp(data) {
      this.currentStampShow = data
      this.controlIdx = null
    },
    handleBackPreview() {
      this.setStamps(this.stampSelected)
      this.saveToStorage()
      this.$router.push({ name: 'preview' })
    },
    handleControl(data) {
      this.controlIdx = data.id
    },
    handleDelete(data) {
      this.$delete(this.stampSelected, data.id)
    },
    selectChange(value) {
      if (value) {
        const currentObject = this.stampSelected[value]
        this.controlIdx = value

        this.defaultRotate = +currentObject.rotation
        this.defaultScale = +currentObject.scaleX
      } else {
        this.controlIdx = ''
      }
    },
    showPopupConfirmDelete() {
      this.$nextTick(() => {
        this.$refs.confirmDeletePopup &&
          this.$refs.confirmDeletePopup.show({
            title: this.mappingLabels.deleteModalTitle,
            message: this.mappingLabels.deleteModalMessage,
            textCancelButton: this.mappingLabels.cancelText,
            textSubmitButton: this.mappingLabels.confirmText,
          })
      })
    },

    resetData() {
      this.setLayout({ reset: true })
      this.setModules({ reset: true })
      this.setExport({ reset: true })
      this.saveToStorage()
    },

    handleClearData() {
      this.$nextTick(() => {
        const objectKeys = []
        for (let objectKey in this.stampSelected) {
          objectKeys.push(objectKey)
        }
        objectKeys.forEach(item => {
          this.$delete(this.stampSelected, item)
        })
        this.$refs.confirmDeletePopup.hide()
        this.$router.push({ name: 'preview' })
      })
    },
  },
  computed: {
    ...mapGetters('settings', [
      'getStamps',
      'getTexts',
      'getBackground',
      'getAvatars',
    ]),
    mappingLabels() {
      return LABELS
    },
    isMobile() {
      return !isMobile().any
    },
  },
  created() {
    this.stampSelected = this.getStamps
  },
}
</script>

<template>
  <div class="page-wrap_content" v-if="!chooseStamp">
    <s-header :hasPreview="true">{{ mappingLabels.stampTitle }}</s-header>
    <div class="stamp" v-if="!chooseStamp">
      <div class="stamp__container-img">
        <!-- <div class="stamp-delete">            
              <a class="btn-delete-img" @click="showPopupConfirmDelete()">
                <x-icon-delete :noCircle="true" :color=colorIconDelete />
                <span>やり直す</span>
              </a>
          </div> -->
        <s-preview
          currentMove="stamp"
          :stampDraw="stampSelected"
          :avatarDraw="getAvatars"
          :textDraw="getTexts"
          :selectedName="controlIdx"
          :backgroundDraw="getBackground"
          @onchangeSelect="selectChange"
        />
      </div>
      <div class="stamp__zoom">
        <div class="stamp__zoom-and-rotate">
          <s-range-input
            :label="'角度'"
            :min="-180"
            :max="180"
            :value="defaultRotate"
            :step="15"
            :disabled="!controlIdx"
            @on-input="handleRotate"
          />
          <s-range-input
            :label="'大きさ'"
            :min="0.25"
            :max="3"
            :value="defaultScale"
            :step="0.05"
            :disabled="!controlIdx"
            @on-input="handleZoom"
          />
        </div>
        <div
          class="stamp__list"
          v-if="Object.values(stampSelected).length"
          v-dragscroll="isMobile"
        >
          <ul
            class="stamp__list-icons"
            v-if="Object.values(stampSelected).length"
            v-dragscroll="isMobile"
          >
            <li
              class="container"
              v-for="(item, idx) of stampSelected"
              :key="`${item.id}-${idx}`"
            >
              <s-choose-item
                class="icons-stamp"
                :data="item"
                :selected="controlIdx === item.id"
                :hasDelete="true"
                :showText="false"
                :innerBorderActive="false"
                @click-item="handleControl"
                @click-delete="handleDelete"
              />
            </li>
          </ul>
        </div>
        <div class="stamp__btns" v-if="Object.values(stampSelected).length < 5">
          <button
            class="s-button add-btn-option"
            @click="handleRedirectSelectStamp"
          >
            <span>
              <p>+</p>
              {{ mappingLabels.addStamp }}</span
            >
          </button>
        </div>
      </div>
      <s-navigate-bar
        class="navigate-bar-fixed"
        @leftClick="$router.push({ name: 'preview' })"
        @rightClick="handleBackPreview"
        >{{ mappingLabels.decideAndBackToPreviewText }}</s-navigate-bar
      >
    </div>
    <s-modal-confirm
      ref="confirmDeletePopup"
      @submit="handleClearData"
    ></s-modal-confirm>
  </div>
  <div class="page-wrap_content" v-else>
    <s-header :hasPreview="true">{{ mappingLabels.chooseStampTlt }}</s-header>
    <div class="stamp add-stamp">
      <div class="choose-stamp__top">
        <div class="choose-stamp__container-img" v-if="currentStampShow.backgroundColor" :style="`background-color: ${currentStampShow.backgroundColor}`">
          <div class="choose-stamp__img">
            <img
              :src="currentStampShow && currentStampShow.thumSrc"
              :alt="currentStampShow && currentStampShow.name"
            />
          </div>
        </div>
        <div class="choose-stamp__container-img" v-else>
          <div class="choose-stamp__img">
            <img
              :src="currentStampShow && currentStampShow.thumSrc"
              :alt="currentStampShow && currentStampShow.name"
            />
          </div>
        </div>
      </div>
      <div class="choose-stamp"></div>
      <div
        class="choose-stamp__bottom"
        id="chooseStampBottom"
        ref="choosestampBottom"
      >
        <div class="choose-stamp_list-wrap">
          <div
            v-for="item of stampsList"
            :key="item.name"
            class="choose-stamp__container"
          >
            <template v-if="item.stamps && item.stamps.length > 0">
              <div class="choose-stamp__type">{{ item.name }}</div>
              <ul class="stamp__list-icons" v-dragscroll="isMobile">
                <li
                  class="container"
                  v-for="(item1, idx) of item.stamps"
                  :key="`stamp${idx}`"
                >
                  <s-choose-item
                    class="icons-stamp icon-item"
                    :data="item1"
                    :showText="false"
                    :selected="currentStampShow.id === item1.id"
                    @click-item="handleSelectStamp"
                  />
                </li>
              </ul>
            </template>
          </div>
        </div>
      </div>
      <s-navigate-bar
        class="navigate-bar-fixed"
        @leftClick="handleBack(false)"
        @rightClick="handleBack(true)"
        >{{ mappingLabels.addStamp }}</s-navigate-bar
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './stamp.scss';
</style>
